import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { OTPForm } from "../../../Components/molecules/AuthForms/OTPForm";
import { ContactSupport } from "../../../Components/molecules/ContactSupport/ContactSupport";
import { AuthWrap } from "../../../Components/templates/AuthWrap/AuthWrap";
import { useAuth } from "../../../Store/AuthContext";
import useOverlayState from "../../../Utils/Hooks/useOverlayState";

export const Otp = () => {
  const [otpAttempts, setOtpAttempts] = useState(0);
  const { t } = useTranslation(["glossary"]);
  const { state } = useAuth();
  const { openOverlay, closeOverlay, OverlayState } = useOverlayState();
  const location = useLocation();
  const navigate = useNavigate();

    //use state to store user role name
    const [userRoleName, setUserRoleName] = useState(null);

  window.onpopstate = function (event) {
    navigate("/signin/enter-username", { replace: true });
  };

  window.onbeforeunload = function (e) {
    navigate("/signin/enter-username", { replace: true });
  };

  return (
    <AuthWrap
      pageTitle={t("auth.verification.title")}
      pageSubheading={t("auth.verification.subheading")}
    >
      <OTPForm
        email={location?.state?.username}
        state={state}
        length={state?.otpLength}
        t={t}
        openContactSupport={() =>
          openOverlay({ OverlayName: "contact-support" })
        }
        setAttempt={setOtpAttempts}
        attempt={otpAttempts}
        onClick={(status) => {
          //update the state of user role name
          setUserRoleName(localStorage.getItem('UserRoleName'));
          if (status === "pass") {
            //navigate to screen
            navigate("/signin/enter-password", {
              state: {
                username: location?.state?.username,
                otpVerified: true,
              },
            });
          } else if (status === "resend") {
            setOtpAttempts(otpAttempts + 1);
          } else if (status === "contact-support") {
            openOverlay({ OverlayName: status });
          }
        }}
      />
      {OverlayState.visible && (
        <ContactSupport
          t={t}
          visible={OverlayState.visible}
          close={closeOverlay}
          userRoleName={userRoleName}
        />
      )}
    </AuthWrap>
  );
};
